<template>
	<transition name="fade" v-if="config.show">
		<div v-if="step == 1" class="modal-box">
			<div class="modal modal-md p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						설문 만들기
					</h2>
					<a class="close" @click="config.show = false">×</a>
				</div>
				<!-- //end .modal-header -->
				<div class="modal-body p-10 clearfix">
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								설문명
							</span>
							<input class="form-control full-width b-l-0" type="text">
						</div>
					</div>
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								설문대상
							</span>
							<span class="input-group-addon v-mid clearfix">
								<div class="checkbox">
									<input id="chek1" type="radio" name="check1" checked="">
									<label for="chek1">회원</label>
								</div>
								<div class="checkbox">
									<input id="chek2" type="radio" name="check1">
									<label for="chek2" style="border-radius:0 5px 5px 0">제한없음</label>
								</div>
							</span>
						</div>
					</div>
					<div class="round m-b-10">
						<div class="input-group full-width">
							<input class="form-control full-width round" type="text" placeholder="설문대상을 입력하세요.">
						</div>
					</div>
				</div>
				<!-- //end .modal-body -->
				<div class="modal-footer p-10 clearfix">
					<button @click="step = 2" class="btn bg-deepblue text-white full-width m-t-30 round" type="button">만들기</button>
				</div>
			</div>
		</div>
		<div v-if="step == 2"  id="modal" class="modal-box">
			<div class="modal modal-md p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						설문자 선택
					</h2>
					<a class="close" @click="config.show = false">×</a>
				</div>
				<!-- //end .modal-header -->
				<div class="modal-body p-10 clearfix">
					<div class="input-group full-width m-t-15 m-b-15">
						<span class="input-group-addon p-r-5">
							<select class="form-control round m-b-0">
								<option>강의시작일</option>
								<option>강의종료일</option>
							</select>
						</span>
						<span class="input-group-addon v-mid">
							<label for="" class="cal">
								<input class="form-control round m-b-0" type="text">
							</label>
							~
							<label for="" class="cal">
								<input class="form-control round m-b-0" type="text">
							</label>
						</span>
						<span class="input-group-addon">
							<div class="search-box pull-right w200">
								<input id="search" class="form-control round full-width m-b-0" type="text">
								<label for="search">검색</label>
							</div>
						</span>
					</div>
					<div class="list-box" style="height: 250px;">
						<table class="full-width table-condensed table-hover text-center m-t-0 m-b-0">
							<tbody>
								<tr>
									<td>김똘똘</td>
									<td>010-0000-0000</td>
									<td>2019년 6월 2일 ~ 2019년 7월 2일</td>
									<td>25</td>
									<td>최민희</td>
									<td>수료</td>
								</tr>
								<tr>
									<td>김똘똘</td>
									<td>010-0000-0000</td>
									<td>2019년 6월 2일 ~ 2019년 7월 2일</td>
									<td>25</td>
									<td>최민희</td>
									<td>수료</td>
								</tr>
								<tr>
									<td>김똘똘</td>
									<td>010-0000-0000</td>
									<td>2019년 6월 2일 ~ 2019년 7월 2일</td>
									<td>25</td>
									<td>최민희</td>
									<td>수료</td>
								</tr>
								<tr>
									<td>김똘똘</td>
									<td>010-0000-0000</td>
									<td>2019년 6월 2일 ~ 2019년 7월 2일</td>
									<td>25</td>
									<td>최민희</td>
									<td>수료</td>
								</tr>
								<tr>
									<td>김똘똘</td>
									<td>010-0000-0000</td>
									<td>2019년 6월 2일 ~ 2019년 7월 2일</td>
									<td>25</td>
									<td>최민희</td>
									<td>수료</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="pagination-box text-center">
						<ul class="pagination">
							<li class="disabled none">
								<a href="#" aria-label="Previous">
									<img src="images/prev.png" alt="이전">
								</a>
							</li>
							<li class="active"><a href="#">1</a></li>
							<li><a href="#">2</a></li>
							<li><a href="#">3</a></li>
							<li><a href="#">4</a></li>
							<li><a href="#">5</a></li>
							<li class="none">
								<a href="#" aria-label="Next">
									<img src="images/next.png" alt="">
								</a>
							</li>
						</ul>
					</div>
				</div>
				<!-- //end .modal-body -->
				<div class="modal-footer p-10 clearfix">
					<button @click="config.show = false" class="btn bg-deepblue text-white full-width m-t-30 round" type="button">확인</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "ModalClassSurveyRegister",

	default: function() {
		return {
			show: false
		}
	},
	data (){
		return  {
			step : 1,
		}
	},

	props: {
		config: Object
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>